module.exports = __webpack_public_path__ + "img/banner.2bc8e4c1.png";